var render = function render(){var _vm=this,_c=_vm._self._c;return _c('piece-card',{attrs:{"title":"车场动态"}},[_c('div',{staticClass:"crowd-list flex-box"},_vm._l((_vm.infoList),function(item,index){return _c('InfoCard',{key:index,staticClass:"info-item flex-grow",attrs:{"title":item.title,"value":item.value}})}),1),_c('ScreenTable',{staticClass:"car-table",attrs:{"data":_vm.data,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }